import React from 'react';  
import { Settings } from 'lucide-react';  
  
const ControlTiempo = ({ tiempoEntreCartas, onTiempoChange }) => {  
  return (  
    <div className="bg-white/80 backdrop-blur-xl rounded-2xl p-6 shadow-lg mb-6">  
      <div className="flex items-center gap-3 mb-4">  
        <Settings className="w-6 h-6 text-blue-600" />  
        <h3 className="font-bold text-lg">Tiempo entre cartas</h3>  
      </div>  
      <div className="flex items-center gap-4">  
        <input  
          type="range"  
          min={1}  
          max={10}  
          value={tiempoEntreCartas}  
          onChange={(e) => onTiempoChange(Number(e.target.value))}  
          className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"  
          style={{  
            background: `linear-gradient(to right, #10b981 ${((tiempoEntreCartas - 1) / 9) * 100}%, #ddd ${((tiempoEntreCartas - 1) / 9) * 100}%)`  
          }}  
        />  
        <span className="font-semibold text-lg">{tiempoEntreCartas} seg</span>  
      </div>  
    </div>  
  );  
};  
  
export default ControlTiempo;